module.exports = __webpack_public_path__ + "pic/42.e497160b.png";